// Studio routes that more than one part of the shell links to.
export const STUDIO_HOME = '/studio';
export const STUDIO_TRENDING = '/studio/trending';
// Plan, credits, card and invoices. The core's emails and the Stripe card portal
// return here (`STUDIO_PAYMENTS_PLAN_PATH`).
export const STUDIO_PLAN = '/studio/plan';
// Direct Messages (contract 2.14.0): the home, the list, its trash, the channel connection, one
// automation (`/<id>` its results, `/<id>/edit` its editor) and the inbox.
export const STUDIO_AUTOMATIONS = '/studio/automations';
export const STUDIO_AUTOMATIONS_LIST = '/studio/automations/list';
export const STUDIO_AUTOMATIONS_TRASH = '/studio/automations/trash';
export const STUDIO_AUTOMATIONS_CONNECT = '/studio/automations/connect';
export const STUDIO_INBOX = '/studio/inbox';
export const automationPath = id => `${STUDIO_AUTOMATIONS}/${id}`;
export const automationEditPath = id => `${STUDIO_AUTOMATIONS}/${id}/edit`;
export const conversationPath = id => `${STUDIO_INBOX}/${id}`;
const within = (pathname, base) => pathname === base || pathname.startsWith(`${base}/`);
export const isAutomationsPath = pathname => within(pathname, STUDIO_AUTOMATIONS);
export const isInboxPath = pathname => within(pathname, STUDIO_INBOX);
// Pages scroll inside the shell, under the header's blur (`studio-screen--page`).
export const STUDIO_PAGES = [STUDIO_TRENDING, STUDIO_PLAN];
export const isStudioPage = pathname => STUDIO_PAGES.includes(pathname) || isAutomationsPath(pathname) || isInboxPath(pathname);
// The public template generator: the art editor alone, templates in and out as JSON files.
export const STUDIO_ART_TEMPLATE_GENERATOR = '/studio/art-template-generator';
